import { UsersPickerModalComponent } from './components/modal/users-picker-modal.component';
import { UsersPickerComponent } from './users-picker.component';

export default angular
  .module('sfMobile.components.users-picker', [])
  .component('usersPickerModal', UsersPickerModalComponent)
  .component('usersPicker', UsersPickerComponent).name;
